import Immutable from 'immutable';
// types
import DesignTypes from '~/constants/types/DesignTypes';
import {ERROR_MESSAGES} from '~/constants/SaveConstants';

export function initialState() {
  return null;
}

export default function path(state = initialState(), action) {
  switch (action.type) {
    case DesignTypes.SAVE:
      return null;
    case DesignTypes.SAVE_SUCCESS: {
      const {response, emailSent} = action.payload;
      return Immutable.Map({
        response,
        emailSent
      });
    }
    case DesignTypes.SAVE_FAILED: {
      const {errors} = action.payload.error;
      const emailError = errors.accountid && errors.accountid.join(' ');
      const designExists = errors.base && errors.base.includes('design_exists');
      const errorProperties = Object.keys(errors).filter(
        errorName => errorName !== 'base' && errorName !== 'accountid'
      );
      const nameErrorArray = errorProperties.reduce(
        (accumulator, errorName) => {
          let errorArray = errors[errorName];
          if (ERROR_MESSAGES[errorName]) {
            errorArray = [
              `${action.payload.designName} ${ERROR_MESSAGES[errorName]}`
            ];
          }
          return accumulator ? accumulator.concat(errorArray) : errorArray;
        },
        null
      );
      return Immutable.Map({
        errors: {
          name: nameErrorArray ? nameErrorArray.join(' ') : undefined,
          email: emailError,
          designExists
        },
        response: action.payload.response,
        emailSent: false
      });
    }
    default:
      return state;
  }
}
